import { Component } from '@angular/core';

@Component({
  selector: 'app-fona',
  imports: [],
  templateUrl: './fona.component.html',
  styleUrl: './fona.component.scss'
})
export class FonaComponent {

}
